// 승객 화면 노선도 스트립의 «현재» 정류장 판정 — 순수 함수(Firebase·React import 0).
//
// 🔴 2026-10-21 way 실주행(과천대로): 기사앱은 «회사 도착 15:02 · 현재» 인데 승객앱 노선도는
//    한 정류장 뒤(인덕원힐스테이트)에 «현재» 를 찍었다. 15:00 에도 똑같이 한 칸 늦었다.
//    기사앱은 정류장 **반경(회사 설정 stopArriveRadiusM, 기본 100m) 안에 들어온 순간** 도착으로
//    치는데, 승객앱은 경로 진행거리가 정류장 투영점 − 40m(PASSED_MARGIN_M) 를 넘어야 «지났다» 로
//    쳤다. 그 사이 60m 남짓 — 정류장 앞에 세우고 기다리는 동안 내내 — 두 앱이 한 칸 어긋난다.
//    → 진행거리 판정(종전 그대로)에 «기사앱과 같은 반경 도착» 을 더한다.
//
// 🔴 반경만 보면 안 된다 — 출발지와 종점이 붙어 있는 노선(왕복·순환)은 출발하자마자 종점
//    반경 안이다. 그래서 경로 진행거리로도 그 정류장이 **바로 앞**(반경의 2배 안)일 때만 인정한다.

/**
 * @param {object} a
 * @param {number[]} a.stopProgresses  정류장별 경로 진행거리(m) — 정류장 순서대로
 * @param {number}   a.busProgress     버스 경로 진행거리(m)
 * @param {number}   a.marginM         진행거리 «지남» 마진(종전 PASSED_MARGIN_M)
 * @param {(number|null)[]} a.stopDists 버스(원 GPS)↔정류장 직선거리(m). 모르면 null
 * @param {number}   a.arriveRadiusM   도착 반경(m) — 기사앱과 같은 값
 * @param {number|null} [a.prevIdx]    직전 판정값(같은 노선·같은 운행) — 정류장 앞 정차 중 유지용
 * @returns {number} «현재» 정류장 인덱스(최소 0)
 */
export function stripBusIndex({ stopProgresses, busProgress, marginM, stopDists, arriveRadiusM, prevIdx = null }) {
  if (!Array.isArray(stopProgresses) || stopProgresses.length === 0 || !Number.isFinite(busProgress)) return 0;
  const r = Number.isFinite(arriveRadiusM) && arriveRadiusM > 0 ? arriveRadiusM : 100;
  const ahead = (i) => stopProgresses[i] - busProgress;   // 앞으로 남은 경로거리(m)

  // ① 종전 규칙 — 진행거리가 지난 마지막 정류장
  let idx = 0;
  for (let i = 0; i < stopProgresses.length; i++) {
    if (stopProgresses[i] <= busProgress + marginM) idx = i;
  }

  // ② 기사앱과 같은 반경 도착 — 단, 경로상으로도 바로 앞일 때만(왕복·순환 노선 오판 차단)
  for (let i = idx + 1; i < stopProgresses.length; i++) {
    const d = Array.isArray(stopDists) ? stopDists[i] : null;
    if (d != null && Number.isFinite(d) && d <= r && ahead(i) <= r * 2) idx = i;
  }

  // ③ 한 번 도착한 정류장은 그 앞에 서 있는 동안 유지(GPS 흔들림으로 반경을 잠깐 벗어나도 되돌리지 않음)
  if (Number.isInteger(prevIdx) && prevIdx > idx && prevIdx < stopProgresses.length && ahead(prevIdx) <= r * 2) {
    idx = prevIdx;
  }
  return idx;
}
